import React from 'react';
import ReorderIcon from 'material-ui/svg-icons/action/reorder';
import getScrollParent from 'utils/getScrollParent';
import {Link} from 'react-router';
import GenericLink from 'components/GenericLink';

// See render fn
function isChrome() {
  let isChromium = window.chrome,
    winNav = window.navigator,
    vendorName = winNav.vendor,
    isOpera = winNav.userAgent.indexOf('OPR') > -1,
    isIEedge = winNav.userAgent.indexOf('Edge') > -1,
    isIOSChrome = winNav.userAgent.match('CriOS');

  if (isIOSChrome) {
    return true;
  } else if (
    isChromium !== null &&
    typeof isChromium !== 'undefined' &&
    vendorName === 'Google Inc.' &&
    isOpera === false &&
    isIEedge === false
  ) {
    return true;
  } else {
    return false;
  }
}

const scrollDistance = 150;

export default class TeamsTableRow extends React.PureComponent {
  constructor() {
    super(...arguments);
    this.onDragStart = this.onDragStart.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.onDrag = this.onDrag.bind(this);
  }
  onDragStart(e) {
    // Firefox requires that you set something to the dataTransfer object
    // otherwise dragging simply won't work.  Very strange api requirement..
    // See https://stackoverflow.com/a/19055350
    e.dataTransfer.setData('text', 'anything');
    e.dataTransfer.setDragImage(this.ref, 0, 0);
    e.dataTransfer.effectAllowed = 'move';

    // Doing this immediately for whatever reason causes the ridiculous drag
    // and drop api to not show the row being dragged as the 'ghost image' ('dragImage')
    // under the cursor.. I suspect because this callback causes a state change which
    // triggers a re-render and confuses the browser somehow
    setTimeout(() => this.props.onStageTeamForMove(this.props.team));
  }
  onDragEnd(e) {
    if (e.dataTransfer.dropEffect === 'none') {
      this.props.onDiscardTeamMove();
    }
  }
  onDrag({clientY}) {
    const scrollParent = getScrollParent(this.ref);
    if (!scrollParent) {
      return null;
    }
    if (clientY < scrollDistance) {
      scrollParent.scrollTop = scrollParent.scrollTop - 1;
    }
    if (clientY > window.innerHeight - scrollDistance) {
      scrollParent.scrollTop = scrollParent.scrollTop + 1;
    }
  }
  render() {
    const {team, showTeamDialog} = this.props;
    return (
      <tr ref={ref => (this.ref = ref)}>
        <td
          className="reorder"
          onDragStart={this.onDragStart}
          onDrag={
            // this is a terrible hack but autoscroll is only needed
            // in chrome because other browsers let you scroll with the
            // mousewheel while dragging.  Also, attaching an onDrag
            // event in other browsers (even if it is a noop function)
            // slows them down to a crawl
            isChrome() ? this.onDrag : undefined
          }
          onDragEnd={this.onDragEnd}
          draggable="true">
          <ReorderIcon />
        </td>
        <td>
          <GenericLink onClick={() => showTeamDialog(team)}>{team.name}</GenericLink>
        </td>
        <td>
          {team.usersCount > 0 ? (
            <Link to={`/admin/users?teamId=${team.id}`}>{team.usersCount}</Link>
          ) : (
            team.usersCount
          )}
        </td>
      </tr>
    );
  }
}
